import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../utils/propUtils';
import VeltReactionsPanelItemsWireframe from './VeltReactionsPanelItemsWireframe/VeltReactionsPanelItemsWireframe';
var VeltReactionsPanelWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-reactions-panel-wireframe", __assign({}, transformedProps), children));
};
VeltReactionsPanelWireframe.Items = VeltReactionsPanelItemsWireframe;
export default VeltReactionsPanelWireframe;
